export const SOUND_EFFECTS = {
    effects: [
        // Universal sfx for games are set to *
        {
            id: 'heavy_click',
            path: 'sound-effects/heavy_click.mp3',
            description: 'Heavy click for entrance',
            category: 'movement',
            games: ['67d1c7c8d303f4b1017260a4'],
        },
        {
            id: 'timer_tick',
            path: 'sound-effects/timer_tick.mp3',
            description: 'Timer tick for remaining time',
            category: 'timer',
            games: ['*'],
        },
        {
            id: 'typewriter_key',
            path: 'sound-effects/typewriter_key.mp3',
            description: 'Typewriter key for type reveals',
            category: 'reveal',
            games: ['67d1c7c8d303f4b1017260a4', '6a3349523db03ba5ecbf1db2'],
        },
        {
            id: 'sparkly_reveal',
            path: 'sound-effects/sparkly_reveal.mp3',
            description: 'Sparkly reveal for appearance reveal',
            category: 'reveal',
            games: ['67d1c7c8d303f4b1017260a4'],
        },
        {
            id: 'audience_laugh1',
            path: 'sound-effects/audience_laugh1.mp3',
            description: 'Laugh reaction',
            category: 'audience',
            games: ['67d1c7c8d303f4b1017260a4'],
        },
        {
            id: 'boing',
            path: 'sound-effects/boing.mp3',
            description: 'Boing for spring-in entrance',
            category: 'movement',
            games: ['67d1c7c8d303f4b1017260a4'],
        },
        {
            id: 'curtain_slide',
            path: 'sound-effects/curtain_slide.mp3',
            description: 'Curtain slide',
            category: 'reveal',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'three_levels',
            path: 'sound-effects/three_levels.mp3',
            description: 'Three levels sound effect',
            category: 'game',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'success_chime',
            path: 'sound-effects/success_chime.mp3',
            description: 'Success chime sound effect',
            category: 'game',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'super_ominous',
            path: 'sound-effects/super_ominous.mp3',
            description: 'Super ominous sound effect',
            category: 'game',
            games: ['68016cb23f0914bff706b7ca', '6921e33b0eef394c89845fb8'],
        },
        {
            id: 'intrigued_audience',
            path: 'sound-effects/intrigued_audience.mp3',
            description: 'Intrigued audience sound effect',
            category: 'game',
            games: ['68016cb23f0914bff706b7ca', '69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'portal_jump',
            path: 'sound-effects/portal_jump.mp3',
            description: 'Portal jump sound effect',
            category: 'game',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'horn_fanfare',
            path: 'sound-effects/horn_fanfare.mp3',
            description: 'Horn fanfare sound effect',
            category: 'game',
            games: [
                '68016cb23f0914bff706b7ca',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
            ],
        },
        {
            id: 'hyperspace_whoosh',
            path: 'sound-effects/hyperspace_whoosh.mp3',
            description: 'Whoosh effect for movements',
            category: 'movement',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'cash_register',
            path: 'sound-effects/cash_register.mp3',
            description: 'Cash register sound effect',
            category: 'game',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'nom_nom_nom',
            path: 'sound-effects/nom_nom_nom.mp3',
            description: 'Nom nom nom sound effect',
            category: 'game',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'tingaling',
            path: 'sound-effects/tingaling.mp3',
            description: 'Tingaling sound effect',
            category: 'game',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'slide_in',
            path: 'sound-effects/slide_in.mp3',
            description: 'Slide in sound effect',
            category: 'reveal',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'sand_slide',
            path: 'sound-effects/sand_slide.mp3',
            description: 'Sand slide sound effect',
            category: 'reveal',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'page_turn',
            path: 'sound-effects/page_turn.mp3',
            description: 'Page turn for subtle changes',
            category: 'reveal',
            games: [
                '68eb1f40d63530c3bfd356e6',
                '6921e33b0eef394c89845fb8',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
                '6a4443ab95150cffae4f482e',
                '6a4445679a8400bf1b9aae8d',
            ],
        },
        {
            id: 'drum_roll',
            path: 'sound-effects/drum_roll.mp3',
            description: 'Drum roll for determining winner',
            category: 'reveal',
            games: ['68eb1f40d63530c3bfd356e6'],
        },
        {
            id: 'magic_twinkle',
            path: 'sound-effects/magic_twinkle.mp3',
            description: 'Magic twinkle for reveal',
            category: 'reveal',
            games: ['68eb1f40d63530c3bfd356e6', '6701bc6c35797c2928318643'],
        },
        {
            id: 'wet_splat',
            path: 'sound-effects/wet_splat.mp3',
            description: 'Wet splat for reveal',
            category: 'reveal',
            games: ['68eb1f40d63530c3bfd356e6', '69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'stinky_fart',
            path: 'sound-effects/stinky_fart.mp3',
            description: 'Stinky fart for Feed The Farm crap outcome',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'tuba_bonk',
            path: 'sound-effects/tuba_bonk.mp3',
            description: 'Tuba bonk for reveal',
            category: 'reveal',
            games: ['68eb1f40d63530c3bfd356e6'],
        },
        {
            id: 'big_whoosh',
            path: 'sound-effects/big_whoosh.mp3',
            description: 'Big whoosh for reveal',
            category: 'exit',
            games: ['68eb1f40d63530c3bfd356e6'],
        },
        {
            id: 'bubble_pop',
            path: 'sound-effects/bubble_pop.mp3',
            description: 'Bubble pop sound effect',
            category: 'game',
            games: ['68eb1f40d63530c3bfd356e6', '693bad642f3a8ff742190144'],
        },
        {
            id: 'whistle_slide',
            path: 'sound-effects/whistle_slide.mp3',
            description: 'Whistle slide sound effect',
            category: 'reveal',
            games: [
                '68eb1f40d63530c3bfd356e6',
                '693bad642f3a8ff742190144',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
                '6a4445679a8400bf1b9aae8d',
            ],
        },
        {
            id: 'whoosh_whiplash',
            path: 'sound-effects/whoosh_whiplash.mp3',
            description: 'Whoosh whiplash sound effect',
            category: 'movement',
            games: [
                '6921e33b0eef394c89845fb8',
                '69ac5a4510c9adc947dc1981',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
                '6a4445679a8400bf1b9aae8d',
            ],
        },
        {
            id: 'whoosh_fast',
            path: 'sound-effects/whoosh_fast.mp3',
            description: 'Whoosh fast sound effect',
            category: 'movement',
            games: [
                '6921e33b0eef394c89845fb8',
                '69ac5a4510c9adc947dc1981',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
                '6a4443ab95150cffae4f482e',
                '6a4445679a8400bf1b9aae8d',
            ],
        },
        {
            id: 'level_up_charm',
            path: 'sound-effects/level_up_charm.mp3',
            description: 'Level up charm sound effect',
            category: 'game',
            games: ['6921e33b0eef394c89845fb8'],
        },
        {
            id: 'level_down_sad',
            path: 'sound-effects/level_down_sad.mp3',
            description: 'Level down sad sound effect',
            category: 'game',
            games: ['6921e33b0eef394c89845fb8', '69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'gong_hit',
            path: 'sound-effects/gong_hit.mp3',
            description: 'Gong hit sound effect',
            category: 'game',
            games: ['6921e33b0eef394c89845fb8'],
        },
        {
            id: 'flourish_warm',
            path: 'sound-effects/flourish_warm.mp3',
            description: 'Flourish warm sound effect',
            category: 'game',
            games: ['6921e33b0eef394c89845fb8'],
        },
        {
            id: 'shocked_crowd',
            path: 'sound-effects/shocked_crowd.mp3',
            description: 'Shocked crowd sound effect',
            category: 'reveal',
            games: ['693bad642f3a8ff742190144'],
        },
        {
            id: 'level_up_pipe',
            path: 'sound-effects/level_up_pipe.mp3',
            description: 'Level up pipe sound effect',
            category: 'reveal',
            games: ['693bad642f3a8ff742190144'],
        },
        {
            id: 'lock_click',
            path: 'sound-effects/lock_click.mp3',
            description: 'Lock click sound effect',
            category: 'game',
            games: ['693bad642f3a8ff742190144'],
        },
        {
            id: 'pencil_scratch',
            path: 'sound-effects/pencil_scratch.mp3',
            description: 'Pencil scratch sound effect',
            category: 'reveal',
            games: ['6944abab5d2f2d3fde971460', '6a4443ab95150cffae4f482e'],
        },
        {
            id: 'yum',
            path: 'sound-effects/yum.mp3',
            description: 'Yum sound effect',
            category: 'reveal',
            games: ['6944abab5d2f2d3fde971460'],
        },
        {
            id: 'level_up_coin',
            path: 'sound-effects/level_up_coin.mp3',
            description: 'Level up coin sound effect',
            category: 'reveal',
            games: [
                '6944abab5d2f2d3fde971460',
                '69c55319c9763aa207ae0fb2',
                '6a3349523db03ba5ecbf1db2',
            ],
        },
        {
            id: 'level_up_strum',
            path: 'sound-effects/level_up_strum.mp3',
            description: 'Ascending strum as round scores begin to reveal',
            category: 'reveal',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'knife_chop',
            path: 'sound-effects/knife_chop.mp3',
            description: 'Knife chop sound effect',
            category: 'timer',
            games: ['6944abab5d2f2d3fde971460'],
        },
        {
            id: 'audience_cheer_1',
            path: 'sound-effects/audience_cheer_1.mp3',
            description: 'Audience cheer 1 sound effect',
            category: 'game',
            games: ['6944abab5d2f2d3fde971460'],
        },
        {
            id: 'bomb_drop_whistle3',
            path: 'sound-effects/bomb_drop_whistle3.mp3',
            description: 'Bomb drop whistle for destroy setup',
            category: 'movement',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'bomb_drop_explosion',
            path: 'sound-effects/bomb_drop_explosion.mp3',
            description: 'Bomb drop explosion for destroy impact',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'snicker_breath',
            path: 'sound-effects/snicker_breath.mp3',
            description: 'Breathy bunny snicker for movement start',
            category: 'movement',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'snicker_consistent',
            path: 'sound-effects/snicker_consistent.mp3',
            description: 'Consistent bunny snicker for movement start',
            category: 'movement',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'snicker_funny',
            path: 'sound-effects/snicker_funny.mp3',
            description: 'Funny bunny snicker for bunnies-win game over',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'bittersweet_heaven',
            path: 'sound-effects/bittersweet_heaven.mp3',
            description: 'Bittersweet heaven rise for bunny angel ascension',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'dirt_trudge2',
            path: 'sound-effects/dirt_trudge2.mp3',
            description: 'Dirt trudge layer for bunny movement',
            category: 'movement',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'hollow_whisper',
            path: 'sound-effects/hollow_whisper.mp3',
            description: 'Hollow whisper for skull swirl',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'victory_lift',
            path: 'sound-effects/victory_lift.mp3',
            description: 'Victory lift for players-win game over',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'what_the_fox3',
            path: 'sound-effects/what_the_fox3.mp3',
            description: 'Fox placement sting',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'block_clunk',
            path: 'sound-effects/block_clunk.mp3',
            description: 'Block placement clunk',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'radioactive_siren2',
            path: 'sound-effects/radioactive_siren2.mp3',
            description: 'Poison placement siren',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'animal_pig_oink',
            path: 'sound-effects/animal_pig_oink.mp3',
            description: 'Pig oink for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_cow_moo',
            path: 'sound-effects/animal_cow_moo.mp3',
            description: 'Cow moo for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_sheep_baa',
            path: 'sound-effects/animal_sheep_baa.mp3',
            description: 'Sheep baa for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_goat_bleat',
            path: 'sound-effects/animal_goat_bleat.mp3',
            description: 'Goat bleat for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_horse_neigh',
            path: 'sound-effects/animal_horse_neigh.mp3',
            description: 'Horse neigh for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_donkey_bray',
            path: 'sound-effects/animal_donkey_bray.mp3',
            description: 'Donkey bray for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_chicken_cluck',
            path: 'sound-effects/animal_chicken_cluck.mp3',
            description: 'Chicken cluck for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_duck_quack',
            path: 'sound-effects/animal_duck_quack.mp3',
            description: 'Duck quack for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_owl_hoot',
            path: 'sound-effects/animal_owl_hoot.mp3',
            description: 'Owl hoot for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_turkey_gobble',
            path: 'sound-effects/animal_turkey_gobble.mp3',
            description: 'Turkey gobble for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_dog_bark',
            path: 'sound-effects/animal_dog_bark.mp3',
            description: 'Dog bark for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_cat_meow',
            path: 'sound-effects/animal_cat_meow.mp3',
            description: 'Cat meow for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_mouse_squeak',
            path: 'sound-effects/animal_mouse_squeak.mp3',
            description: 'Mouse squeak for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'animal_llama_ack',
            path: 'sound-effects/animal_llama_ack.mp3',
            description: 'Llama ack for animal avatar joins and swaps',
            category: 'game',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'rabbit_crunching',
            path: 'sound-effects/rabbit_crunching.mp3',
            description: 'Rabbit crunching for carrot or lettuce placement',
            category: 'game',
            games: ['69ac5a4510c9adc947dc1981', '69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'stamp_thwack',
            path: 'sound-effects/stamp_thwack.mp3',
            description: 'Rubber OK-stamp thwack for Okie Dokie approvals and reveals',
            category: 'reveal',
            games: ['6a3349523db03ba5ecbf1db2'],
        },
        {
            id: 'foliage_rustle',
            path: 'sound-effects/foliage_rustle.mp3',
            description: 'Leafy bush rustle for the Wild Things new-specimen sighting interstitial',
            category: 'game',
            games: ['6a4443ab95150cffae4f482e'],
        },
        {
            id: 'bullet_shot',
            path: 'sound-effects/bullet_shot.mp3',
            description: 'Western gunshot for sequential Wanted charge-vote reveals',
            category: 'reveal',
            games: ['6a4445679a8400bf1b9aae8d'],
        },
        {
            id: 'western_horn',
            path: 'sound-effects/western_horn.mp3',
            description: 'Western horn sting for the Wanted crime reveal',
            category: 'reveal',
            games: ['6a4445679a8400bf1b9aae8d'],
        },
        {
            id: 'western_guitar',
            path: 'sound-effects/western_guitar.mp3',
            description: 'Western guitar sting for Wanted suspect and game-over reveals',
            category: 'reveal',
            games: ['6a4445679a8400bf1b9aae8d'],
        },
        {
            id: 'cha_ching',
            path: 'sound-effects/cha_ching.mp3',
            description: 'Cash-register reward for Wanted avatar score reveals',
            category: 'game',
            games: ['6a4445679a8400bf1b9aae8d'],
        },
    ],
};
//# sourceMappingURL=soundEffects.js.map